import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { displayFont, monoFont, tokens } from '../theme.js';

export default function EcosystemVisual() {
  const { t } = useTranslation();
  const items = t('ecosystem.items', { returnObjects: true });

  return (
    <Box
      aria-label={t('ecosystem.ariaLabel')}
      sx={{
        position: 'relative',
        minWidth: 0,
        width: '100%',
        maxWidth: 430,
        mx: 'auto',
        p: { xs: 2, sm: 3 },
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: '18% 16%',
          border: `1px solid ${tokens.lineOnDark}`,
          borderRadius: '50%',
        },
      }}
    >
      <Paper
        elevation={0}
        sx={{
          position: 'relative',
          zIndex: 1,
          mb: 2,
          p: 3,
          color: '#fff',
          bgcolor: 'rgba(23, 58, 45, 0.94)',
          border: `1px solid ${tokens.lineOnDark}`,
          boxShadow: '0 24px 56px rgba(0,0,0,0.28)',
        }}
      >
        <Typography sx={{ fontFamily: monoFont, color: 'primary.main', fontSize: '0.7rem', letterSpacing: '0.12em' }}>
          {t('ecosystem.label')}
        </Typography>
        <Typography sx={{ fontFamily: displayFont, fontWeight: 700, fontSize: '1.7rem', mt: 0.75 }}>
          Caurex
        </Typography>
        <Typography sx={{ color: tokens.mutedOnDark, mt: 1 }}>{t('ecosystem.body')}</Typography>
      </Paper>
      <Box sx={{ position: 'relative', zIndex: 1, display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' }, gap: 1.25 }}>
        {items.map((item, index) => (
          <Paper
            key={item.title}
            elevation={0}
            sx={{ p: 2, minHeight: 112, bgcolor: 'background.paper', borderTop: `3px solid ${index === 1 ? tokens.orange : tokens.teal}` }}
          >
            <Typography sx={{ fontFamily: monoFont, color: 'primary.dark', fontSize: '0.65rem', letterSpacing: '0.08em' }}>
              {String(index + 1).padStart(2, '0')}
            </Typography>
            <Typography sx={{ fontFamily: displayFont, fontWeight: 700, fontSize: '0.95rem', mt: 1 }}>
              {item.title}
            </Typography>
            <Typography sx={{ color: 'text.secondary', fontSize: '0.78rem', mt: 0.5 }}>{item.body}</Typography>
          </Paper>
        ))}
      </Box>
    </Box>
  );
}
